import { render, staticRenderFns } from "./OnboardPFACModal.vue?vue&type=template&id=ec702c46&scoped=true"
import script from "./OnboardPFACModal.vue?vue&type=script&lang=js"
export * from "./OnboardPFACModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardPFACModal.vue?vue&type=style&index=0&id=ec702c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec702c46",
  null
  
)

export default component.exports